import React from 'react';
import PropTypes from 'prop-types';
import Location from './Location';
import EditUsers from 'containers/employer_application/job_posts/EditUsers';
import { capitalize, getFormattedDate } from 'utilities';
import { SHORT_FORMAT_DATE_OPTIONS } from 'consts';
function PreviousPosition({ project }) {
  const {
    project_title,
    created_at,
    city_state_list,
    posted_by,
    status,
    remote_percentage,
  } = project.attributes;
  const { view_project_link, duplicate_project_link } = project.links;
  const createdAt = getFormattedDate(
    new Date(created_at),
    SHORT_FORMAT_DATE_OPTIONS,
  );
  return (
    <div className="project">
      <div className="box box-md box-shadow-sm">
        <div className="row">
          <div className="basic-info col-lg-6">
            <div className="title font-md">{project_title}</div>
          </div>
          <div className="action-buttons d-block d-sm-flex text-left col-lg-6 mt-2 mt-md-0">
            <a
              className="view-link d-block text-nowrap"
              href={view_project_link}
            >
              View Job
              <i className="fa fa-eye" />
            </a>
          </div>
        </div>
        <div className="secondary-info row justify-content-between">
          <div className="col-md-2 text-left pl-0 pb-3 pb-lg-0">
            <span className="font-heavy d-block mb-1">Created</span>
            {createdAt}
          </div>
          <div className="col-md-2 text-left pl-0 pb-3 pb-lg-0">
            <span className="font-heavy d-block mb-1">Posted by</span>
            {posted_by}
          </div>
          <div className="col-md-2 text-left pl-0 pb-3 pb-lg-0">
            <span className="font-heavy d-block mb-1">Status</span>
            <span>
              {status === 'pending_removal'
                ? 'Pending Removal'
                : capitalize(status)}
            </span>
          </div>
          <Location
            cityStateList={city_state_list}
            remotePercentage={remote_percentage}
            containerClassnames="col-md-2"
          />
          <div className="edit-container col-md-2 pr-0">
            <a
              href={duplicate_project_link}
              className="tmp-btn lg btn-edit-job"
            >
              Reuse Job
            </a>
          </div>
        </div>
        <div className="text-left mt-3">
          <EditUsers disabled={true} project={project.attributes} />
        </div>
      </div>
    </div>
  );
}

PreviousPosition.propTypes = {
  project: PropTypes.object.isRequired,
};

export default PreviousPosition;
